<template>
  <div>
    <div style="display:flex;">
      <!------------------------------------------
        % of Items Understood x Not Understood within the selected period
      --------------------------------------------------------------------->
      <div class="md-layout-item md-size-50 mx-auto">
        <DataProvider :endpoint='mountUrlAndParams("percentItensUnderstandByNotUnderstand").url' baseUrl='/placeholder'
          :filter='mountUrlAndParams("percentItensUnderstandByNotUnderstand").filter' @success='mountChartPie("percentItensUnderstandByNotUnderstand", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading" />
            <template v-else-if='error || (dataObj.percentItensUnderstandByNotUnderstand.data.series[0].value === 0 && dataObj.percentItensUnderstandByNotUnderstand.data.series[1].value === 0)'>
              <CardNoData :preTitle="$t('curatorship.naturalLanguage')" :title="$t('curatorship.perCentOfItemsUnderstoodVersusNotUnderstood')" :error='error' height='408' />
            </template>
            <chart-card v-else
              header-animation="false"
              :chart-data="dataObj.percentItensUnderstandByNotUnderstand.data"
              :chart-options="dataObj.percentItensUnderstandByNotUnderstand.options"
              chart-type="Pie"
              header-icon
              chart-inside-content
              background-color="green"
              :classNameComponent="percentChartStyle"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">
                  <span style="font-weight: bolder">{{$t('curatorship.naturalLanguage')}}</span>
                  {{$t('curatorship.perCentOfItemsUnderstoodVersusNotUnderstood')}}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item legend">
                    <span v-for='(label, i) in dataObj.percentItensUnderstandByNotUnderstand.options.labels' :key='i'>
                      <i class="fa fa-circle" :class='labelColor(i)'></i>
                      {{ label }}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-----------------------------------------
        % Items Understood x Not Understood in the last 30d
      -------------------------------------------------------->
      <div class="md-layout-item md-size-50 mx-auto">
        <DataProvider :endpoint='mountUrlAndParamsFixedThirtyDays("percentItensUnderstandByNotUnderstand").url' baseUrl='/placeholder'
          :filter='mountUrlAndParamsFixedThirtyDays("percentItensUnderstandByNotUnderstand").filter' @success='mountChartPie("percentItensUnderstandByNotUnderstandFixed", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading" />
            <template v-else-if='error || dataObj.percentItensUnderstandByNotUnderstandFixed.data.series[0].value === 0'>
              <CardNoData :preTitle="$t('curatorship.naturalLanguage')" :title="$t('curatorship.perCentOfItemsUnderstoodVersusNotUnderstoodThirtyDays')" :error='error' height='408' />
            </template>
            <chart-card v-else
              header-animation="false"
              :chart-data="dataObj.percentItensUnderstandByNotUnderstandFixed.data"
              :chart-options="dataObj.percentItensUnderstandByNotUnderstandFixed.options"
              chart-type="Pie"
              header-icon
              chart-inside-content
              background-color="green"
              :classNameComponent="percentChartStyle"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">
                  <span style="font-weight: bolder">{{$t('curatorship.naturalLanguage')}}</span>
                  {{$t('curatorship.perCentOfItemsUnderstoodVersusNotUnderstoodThirtyDays')}}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item legend">
                    <span v-for='(label, i) in dataObj.percentItensUnderstandByNotUnderstand.options.labels' :key='i'>
                      <i class="fa fa-circle" :class='labelColor(i)'></i>
                      {{ label }}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>
    </div>
    <!-- performanceByKnowledge -->
    <div class="md-layout-item md-size-100" v-if="isSefMg">
      <DataProvider :endpoint='mountUrlAndParams("performanceByKnowledge").url' baseUrl='/placeholder' :filter='mountUrlAndParams("performanceByKnowledge").filter' @success='mountChartBar("performanceByKnowledge", $event)'>
        <!-- eslint-disable-next-line -->
        <div slot-scope='{ data: response, error, loading }'>
          <SkeletonLoaderChart v-if="loading"/>
          <template v-else>
            <template v-if='error || dataObj.performanceByKnowledge.data.series[0].length === 0'>
              <CardNoData :preTitle="$t('curatorship.knowledge')" :title="$t('curatorship.performance.performanceByKnowledge')" :error='error' height='463' />
            </template>
            <chart-card
              v-else
              header-animation="false"
              :chart-data="dataObj.performanceByKnowledge.data"
              :chart-options="dataObj.performanceByKnowledge.options"
              chart-type="Bar"
              horizontal-bars="true"
              header-icon
              chart-inside-content
              background-color="green"
              :classNameComponent="efficiencyChartStyle"
              @onClickBar="onClickBar($event, 'performanceByKnowledge')"
            >
              <template slot="chartInsideHeader" >
                <h4 class="title">
                  <span style="font-weight: bolder">{{$t('curatorship.knowledge')}}</span>
                  {{$t('curatorship.performance.performanceByKnowledge')}}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item legend">
                    <span >
                      <i class="fa fa-circle text-donnut-blue"></i>
                        {{$t('efficiency.yes')}}
                    </span>
                    <span >
                      <i class="fa fa-circle text-danger"></i>
                        {{$t('efficiency.no')}}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </template>
        </div>
      </DataProvider>
    </div>
    <CuratorshipUserFeedbackTable
      v-if="showTableObj.performanceByKnowledge"
      :preSelectedMenuFilter="menuFilterObj.performanceByKnowledge"
      :preSelectedAnswerFilter="answerFilterObj.performanceByKnowledge"
      @closeTable="closeTableBasedOnType('performanceByKnowledge')"
      :chartLabels="labelsFilterObj.performanceByKnowledge"
      endpoint="userFeedbackByKnowledge"
      ref='chat-table-reference-knowledge'
      />

    <!-----------------------------------------
      Percentage of Performance by Intent Chart / Comparison of User Feedback Level Information and % Accuracy
    --------------------------------------------------------------------------------------------------------------->
    <div class="md-layout-item md-size-900" v-if="!isYara && !isYaraLtm">
      <DataProvider :endpoint='mountUrlAndParams("performanceByIntention").url' baseUrl='/placeholder' :filter='mountUrlAndParams("performanceByIntent").filter' @success='mountChartBar("performanceByIntent", $event)'>
        <!-- eslint-disable-next-line -->
        <div slot-scope='{ data: response, error, loading }'>
          <SkeletonLoaderChart v-if="loading"/>
          <template v-else>
            <template v-if='error || dataObj.performanceByIntent.data.series[0].length === 0'>
              <CardNoData :preTitle="$t('curatorship.naturalLanguage')" :title="$t('curatorship.performance.performanceByIntent')" :error='error' height='463' />
            </template>
            <chart-card
              v-else
              header-animation="false"
              :chart-data="dataObj.performanceByIntent.data"
              :chart-options="dataObj.performanceByIntent.options"
              chart-type="Bar"
              horizontal-bars="true"
              header-icon
              chart-inside-content
              background-color="green"
              :classNameComponent="efficiencyChartStyle"
              @onClickBar="onClickBar($event, 'performanceByIntent')"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">
                  <span style="font-weight: bolder">{{$t('curatorship.naturalLanguage')}}</span>
                  {{$t('curatorship.performance.performanceByIntent')}}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item legend">
                    <span >
                      <i class="fa fa-circle text-donnut-blue"></i>
                        {{$t('efficiency.yes')}}
                    </span>
                    <span >
                      <i class="fa fa-circle text-danger"></i>
                        {{$t('efficiency.no')}}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </template>
        </div>
      </DataProvider>
    </div>

    <!-------------------------
      Chart Result Table FeedbackByIntent
    -------------------------------------->
    <CuratorshipUserFeedbackTable
      v-if="showTableObj.performanceByIntent"
      :preSelectedMenuFilter="menuFilterObj.performanceByIntent"
      :preSelectedAnswerFilter="answerFilterObj.performanceByIntent"
      @closeTable="closeTableBasedOnType('performanceByIntent')"
      :chartLabels="labelsFilterObj.performanceByIntent"
      endpoint="userFeedback"
      ref="chat-table-reference-intent"/>

    <!-----------------------------------------
        Percentage performance chart by main menu item / comparing user feedback level information and % accuracy
    --------------------------------------------------------------------------------------------------------------->
    <div class="md-layout-item md-size-100" v-if="!isYara && !isYaraLtm">
      <DataProvider :endpoint='mountUrlAndParams("performanceByItem").url' baseUrl='/placeholder' :filter='mountUrlAndParams("performanceByItem").filter' @success='mountChartBar("performanceByMainMenuItem", $event)'>
        <!-- eslint-disable-next-line -->
        <div slot-scope='{ data: response, error, loading }'>
          <SkeletonLoaderChart v-if="loading"/>
          <template v-else>
            <template v-if='error || dataObj.performanceByMainMenuItem.data.series[0].length === 0'>
              <CardNoData :preTitle="$t('curatorship.mainMenu')" :title="$t('curatorship.performance.performanceByMainMenuItem')" :error='error' height='463' />
            </template>
            <chart-card
              v-else
              header-animation="false"
              :chart-data="dataObj.performanceByMainMenuItem.data"
              :chart-options="dataObj.performanceByMainMenuItem.options"
              chart-type="Bar"
              horizontal-bars="true"
              header-icon
              chart-inside-content
              background-color="green"
              :classNameComponent="efficiencyChartStyle"
              @onClickBar="onClickBar($event, 'performanceByMainMenuItem')"
            >
              <template slot="chartInsideHeader" >
                <h4 class="title">
                  <span style="font-weight: bolder">{{$t('curatorship.mainMenu')}}</span>
                  {{$t('curatorship.performance.performanceByMainMenuItem')}}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item legend">
                    <span >
                      <i class="fa fa-circle text-donnut-blue"></i>
                        {{$t('efficiency.yes')}}
                    </span>
                    <span >
                      <i class="fa fa-circle text-danger"></i>
                        {{$t('efficiency.no')}}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </template>
        </div>
      </DataProvider>
    </div>

    <!-------------------------
      Chart Result Table FeedbackByItem
    ------------------------------------>
    <CuratorshipUserFeedbackTable
      v-if="showTableObj.performanceByMainMenuItem"
      :preSelectedMenuFilter="menuFilterObj.performanceByMainMenuItem"
      :preSelectedAnswerFilter="answerFilterObj.performanceByMainMenuItem"
      @closeTable="closeTableBasedOnType('performanceByMainMenuItem')"
      :chartLabels="labelsFilterObj.performanceByMainMenuItem"
      endpoint="userFeedbackByItem"
      ref='chat-table-reference-item'
      />
    <!-- performanceBySubtopic -->
    <div class="md-layout-item md-size-100" v-if="isSefMg">
      <DataProvider :endpoint='mountUrlAndParams("performanceBySubtopic").url' baseUrl='/placeholder' :filter='mountUrlAndParams("performanceBySubtopic").filter' @success='mountChartBar("performanceBySubtopic", $event)'>
        <!-- eslint-disable-next-line -->
        <div slot-scope='{ data: response, error, loading }'>
          <SkeletonLoaderChart v-if="loading"/>
          <template v-else>
            <template v-if='error || dataObj.performanceBySubtopic.data.series[0].length === 0'>
              <CardNoData :preTitle="$t('curatorship.subTheme')" :title="$t('curatorship.performance.performanceBySubtopic')" :error='error' height='463' />
            </template>
            <chart-card
              v-else
              header-animation="false"
              :chart-data="dataObj.performanceBySubtopic.data"
              :chart-options="dataObj.performanceBySubtopic.options"
              chart-type="Bar"
              horizontal-bars="true"
              header-icon
              chart-inside-content
              background-color="green"
              :classNameComponent="efficiencyChartStyle"
              @onClickBar="onClickBar($event, 'performanceBySubtopic')"
            >
              <template slot="chartInsideHeader" >
                <h4 class="title">
                  <span style="font-weight: bolder">{{$t('curatorship.subTheme')}}</span>
                  {{$t('curatorship.performance.performanceBySubtopic')}}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item legend">
                    <span >
                      <i class="fa fa-circle text-donnut-blue"></i>
                        {{$t('efficiency.yes')}}
                    </span>
                    <span >
                      <i class="fa fa-circle text-danger"></i>
                        {{$t('efficiency.no')}}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </template>
        </div>
      </DataProvider>
    </div>
    <CuratorshipUserFeedbackTable
      v-if="showTableObj.performanceBySubtopic"
      :preSelectedMenuFilter="menuFilterObj.performanceBySubtopic"
      :preSelectedAnswerFilter="answerFilterObj.performanceBySubtopic"
      @closeTable="closeTableBasedOnType('performanceBySubtopic')"
      :chartLabels="labelsFilterObj.performanceBySubtopic"
      endpoint="userFeedbackBySubtopic"
      ref='chat-table-reference-subtopic'
      />
  </div>
</template>

<script>
import DataProvider from '@/components/DataProvider'
import SkeletonLoaderChart from '@/components/Reuse/SkeletonLoaderChart'
import CuratorshipUserFeedbackTable from '@/components/CuratorshipUserFeedbackByItem/SearchUserFeedbackByItem.vue'
import CardNoData from '@/components/CardNoData'
import ChartCard from '@/components/Cards/ChartCard'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import moment from 'moment'
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'Curatorship',
  components: {
    DataProvider,
    SkeletonLoaderChart,
    CuratorshipUserFeedbackTable,
    CardNoData,
    ChartCard
  },
  mixins: [isTenantMixin],
  computed: {
    percentChartStyle () {
      return this.isInss ? 'percentChartInss' : 'percentChart'
    },
    efficiencyChartStyle () {
      return this.isInss ? 'efficiencyChart-inss' : 'efficiencyChart'
    },
    charBarFeedbackByItem () {
      return this.dataObj.performanceByMainMenuItem
    }
  },
  data () {
    const optionsObj = {
      height: 0,
      seriesBarDistance: 15,
      reverseData: false,
      horizontalBars: true,
      labelDirection: 'explode',
      axisX: {
        showGrid: false,
        onlyInteger: true,
        showLabel: false
      },
      axisY: {
        offset: 170
      },
      plugins: [
        this.$chartist.plugins
          .tooltip({
            anchorToPoint: true,
            seriesName: true,
            tooltipFnc: this.mountTooltip
          })
          .bind(this),
        this.$chartist.plugins
          .ctBarLabels({
            labelOffset: {
              x: 4
            }
          })
          .bind(this)
      ]
    }
    return {
      dataObj: {
        // pie chart
        percentItensUnderstandByNotUnderstand: {
          data: {
            series: []
          },
          options: {
            labels: ['curatorship.yes', 'curatorship.no'],
            labelInterpolationFnc: (value) => { return value + '%' },
            donut: true,
            donutWidth: 50,
            fullWidth: true,
            height: 300,
            showLabel: true,
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltipPie
                })
                .bind(this)
            ]
          }
        },
        // pie chart
        percentItensUnderstandByNotUnderstandFixed: {
          data: {
            series: []
          },
          options: {
            labels: ['curatorship.yes', 'curatorship.no'],
            labelInterpolationFnc: (value) => { return value + '%' },
            donut: true,
            donutWidth: 50,
            fullWidth: true,
            height: 300,
            showLabel: true,
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltipPie
                })
                .bind(this)
            ]
          }
        },
        // bar chart
        performanceByIntent: {
          data: {
            labels: [],
            series: [
              [], []
            ]
          },
          options: cloneDeep(optionsObj)
        },
        // bar chart
        performanceByMainMenuItem: {
          data: {
            labels: [],
            series: [
              [], []
            ]
          },
          options: cloneDeep(optionsObj)
        },
        performanceBySubtopic: {
          data: {
            labels: [],
            series: [
              [], []
            ]
          },
          options: cloneDeep(optionsObj)
        },
        performanceByKnowledge: {
          data: {
            labels: [],
            series: [
              [], []
            ]
          },
          options: cloneDeep(optionsObj)
        }
      },
      menuFilterObj: {
        'performanceByMainMenuItem': [],
        'performanceByIntent': [],
        'performanceBySubtopic': [],
        'performanceByKnowledge': []
      },
      labelsFilterObj: {
        'performanceByIntent': [],
        'performanceByMainMenuItem': [],
        'performanceBySubtopic': [],
        'performanceByKnowledge': []
      },
      answerFilterObj: {
        'performanceByMainMenuItem': [],
        'performanceByIntent': [],
        'performanceBySubtopic': [],
        'performanceByKnowledge': []
      },
      showTableObj: {
        'performanceByMainMenuItem': false,
        'performanceByIntent': false,
        'performanceBySubtopic': false,
        'performanceByKnowledge': false
      }
    }
  },
  methods: {
    /* ----
      Style
    -------- */
    labelColor (index) {
      switch (index) {
        case 0:
          return 'text-donnut-blue'
        case 1:
          return 'text-danger'
        case 2:
          return 'text-warning'
        case 3:
          return 'text-primary'
        case 4:
          return 'text-success'
        case 5:
          return 'text-dribbble'
        case 6:
          return 'text-tumblr'
      }
    },
    /* --------------
      Get Api and filter
    --------------------- */
    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const fromFromatted = moment(from).format('YYYY-MM-DD[T]HH:mm:ss')
      const to = this.dateInterval.timestamp2
      const toFormatted = moment(to).format('YYYY-MM-DD[T]HH:mm:ss')
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`,
        filter: { to: toFormatted, from: fromFromatted }
      }
    },
    mountUrlAndParamsFixedThirtyDays (endpoint) {
      const to = moment().format('YYYY-MM-DD[T]HH:mm:ss')
      const from = moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`,
        filter: { to: to, from: from }
      }
    },
    mountTooltipPie (meta, value) {
      let tooltipMeta = "<span style='font-weight: bold'>" + meta + '</span>'
      let tooltipValue = '<span> Valor: ' + value + '% </span>'
      return tooltipMeta + '<br/>' + tooltipValue
    },
    /* -----
      Charts
    --------- */
    async mountChartPie (key, response) {
      let itemArr = []
      const labels = response.data.dataLabels.labels
      this.dataObj[key].data.label = labels
      this.dataObj[key].options.labels = labels

      if (labels.length === 1) {
        this.dataObj[key].options.classNames.label = 'onlyOneLabel'
      }

      let total = 0
      for (let i = 0; i < response.data.dataSeries.series.length; i++) {
        total += response.data.dataSeries.series[i]
      }
      for (let i = 0; i < response.data.dataSeries.series.length; i++) {
        let value = response.data.dataSeries.series[i]
        itemArr.push({
          meta: labels[i],
          value: (value > 0 ? Math.round((100 * value) / total) : 0)
        })
      }

      this.dataObj[key].data.series = itemArr
    },
    async mountChartBar (key, response) {
      let maxSize = 0
      this.dataObj[key].data.labels = []
      this.dataObj[key].data.series[0] = []
      this.dataObj[key].data.series[1] = []
      response.data.forEach(row => {
        this.dataObj[key].data.labels.push(row.key)
        this.dataObj[key].data.series[0].push({
          meta: row.subtopics[0].key,
          value: row.subtopics[0].total
        })

        this.dataObj[key].data.series[1].push({
          meta: row.subtopics[1] ? row.subtopics[1].key : this.validateSubtopics(row.subtopics[0].key),
          value: row.subtopics[1] ? row.subtopics[1].total : ''
        })

        this.dataObj[key].options.height = response.data.length * 100

        if (row.key.length > maxSize) {
          maxSize = row.key.length
        }
      })

      const deltaSize = maxSize * 8
      this.dataObj[key].options.axisY.offset = deltaSize
      if (deltaSize < 100) {
        this.dataObj[key].options.axisY.offset = 100
      }
      if (deltaSize > 250) {
        this.dataObj[key].options.axisY.offset = 250
      }
    },
    /* ---------
      Validation
    ------------- */
    validateSubtopics (key) {
      if (key === 'sim') {
        return 'não'
      }
      return 'sim'
    },
    onClickBar (event, type) {
      let eventIndex = event.index
      let findLabel = this.dataObj[type].data.labels.find((item, index) => index === eventIndex)
      this.menuFilterObj[type] = [findLabel]
      this.labelsFilterObj[type] = this.dataObj[type].data.labels
      this.showTableObj[type] = true
      this.answerFilterObj[type] = [event.meta]
    },
    closeTableBasedOnType (type) {
      this.showTableObj[type] = false
      this.menuFilterObj[type] = []
      this.labelsFilterObj[type] = []
      this.answerFilterObj[type] = []
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ct-series-a .ct-slice-donut{
  stroke: #365EB4;
}
::v-deep .percentChartInss .ct-label {
  fill: rgb(255, 255, 255);
  font-weight: 600;
}
::v-deep .ct-series-b .ct-bar {
    stroke: #365EB4;
    cursor: pointer;
}

::v-deep .ct-series-a {
  .ct-bar{
    stroke: #E44C37;
    cursor: pointer;
  }
  .ct-label{
    stroke: #E44C37;
  }
}

.legend {
  display: flex;
  flex-direction: row;

  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    margin-right: 12px;

    i {
      margin-right: 4px;
    }
  }
}
</style>
